import { useDispatch } from 'react-redux';
import { deleteWorkingInterview } from '~/actions/PermanentJobs';
import { useAppSelector, useToggle } from '~/hooks';

interface IUseDeleteWorkingInterviewPayload {
  jobPostingId: string | undefined;
}

export const useDeleteWorkingInterview = ({ jobPostingId }: IUseDeleteWorkingInterviewPayload) => {
  const dispatch = useDispatch();
  const [isWarningOpen, controls] = useToggle();

  const interviews = useAppSelector((state) => {
    if (!jobPostingId) return [];
    return state.permanentJobs.workingInterviews[jobPostingId] ?? [];
  });

  const onDelete = (id: string) => {
    if (!jobPostingId) return;
    if (interviews.length === 1) {
      controls.setOn();
      return;
    }

    dispatch(deleteWorkingInterview({ id, jobPostingId }));
  };

  return {
    isWarningOpen,
    onCloseWarning: controls.setOff,
    onDelete,
  };
};
